import { basicPath } from '../basicPath';

// Helper function to get the correct API path prefix based on domain
const getContractsPath = (endpoint) => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const prefix = hostname.includes('readingplex') ? '/rp' : '/mp';
    return `${prefix}/contracts/${endpoint}`;
};

// Explicit paths (useful when ReadingPlex admin needs MP contract data too)
const getContractsPathExplicit = (prefix, endpoint) => `${prefix}/contracts/${endpoint}`;

export const fetchContractsDaterangeCenter = (params) => async (dispatch) => {
    const path = getContractsPath('daterange-center');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchContractsIds = (params) => async (dispatch) => {
    const path = getContractsPath('ids');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchContractsActiveStudents = (params) => async (dispatch) => {
    const path = getContractsPath('students-active');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchRpContractsActiveStudents = (params) => async (dispatch) => {
    const path = getContractsPathExplicit('/rp', 'students-active');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchMpContractsActiveStudents = (params) => async (dispatch) => {
    const path = getContractsPathExplicit('/mp', 'students-active');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchMpContractsIds = (params) => async (dispatch) => {
    const path = getContractsPathExplicit('/mp', 'ids');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchCurrentContractsStudentIds = (params) => async (dispatch) => {
    const path = getContractsPath('current-student-ids');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchContractsStudentIds = (params) => async (dispatch) => {
    const path = getContractsPath('student-ids');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchContractsStudentNames = (params) => async (dispatch) => {
    const path = getContractsPath('student-names');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const createContract = (params) => async (dispatch) => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const prefix = hostname.includes('readingplex') ? '/rp' : '/mp';
    const path = `${prefix}/contracts`;
    const type = 'post';
    return await basicPath(dispatch, params, path, type);
}

export const updateContract = (params) => async (dispatch) => {
    const path = getContractsPath('all');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const updateContractEndDateOffset = (params) => async (dispatch) => {
    const path = getContractsPath('end-date-offset');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const deleteContract = (params) => async (dispatch) => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const prefix = hostname.includes('readingplex') ? '/rp' : '/mp';
    const path = `${prefix}/contracts`;
    const type = 'delete';
    return await basicPath(dispatch, params, path, type);
}